import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=59ec07d8&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec07d8",
  null
  
)

export default component.exports